import { RequestBuilder, fetchAndRetryIfServerBusy } from '@cvent/nucleus-networking';
import { defaultLanguage } from 'event-widgets/utils/getMatchingLocale';
import Logger from '@cvent/nucleus-logging';
import { ServiceError } from 'event-widgets/utils/errors';

const LOG = new Logger('DataTagsResolutionClient');

function createResolve(environment, eventId, datatags, isPreview,
  language = defaultLanguage) {
  return {
    text: datatags.map(datatag => (
      {
        value: datatag,
        'output-mime-type': 'plaintext'
      }
    )),
    context: {
      eventStub: eventId
    },
    recipients: [
      eventId
    ],
    timePattern: '',
    datePattern: '',
    timeZone: '',
    environment,
    isPreview,
    language
  };
}

function convertResponseToArray(response, eventId) {
  return response[eventId];
}

/**
 * The data tags resolution client
 */
export default class DataTagsResolutionClient {
  constructor(baseUrl, eventId, environment, isPreview) {
    this.dataTagsResolutionBaseUrl = baseUrl + 'datatags-resolution/resolution/v1';
    this.environment = environment;
    this.eventId = eventId;
    this.isPreview = isPreview;
    this.request = new RequestBuilder({ url: this.dataTagsResolutionBaseUrl })
      .withCookies()
      .header('Cvent-Event-ID', eventId);
  }

  async resolve(authToken, datatags, language) {
    const request = this.request
      .url(`${this.dataTagsResolutionBaseUrl}/resolve`)
      .query('environment', this.environment)
      .post()
      .json(createResolve(this.environment, this.eventId, datatags, this.isPreview, language))
      .auth(authToken)
      .build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (!response.ok) {
      const errorMessage = `resolve failed: ${this.dataTagsResolutionBaseUrl}/resolve:
          ${datatags} / ${response.status} - ${response.statusText}`;
      const error = await ServiceError.create(errorMessage, response, request);
      LOG.warn('Error resolving data tags', error);
      return [];
    }
    return convertResponseToArray(await response.json(), this.eventId);
  }
}
